<ng-container *ngIf="regionState$ | async as state">
  <div class="footnote mat-caption">
    <fa-icon icon="map-marker-alt" class="icon-color-primary" xIconSize="large"></fa-icon>
    <span i18n="@@RegionOverlay.Footer.Note">
      Fresh products only available for delivery in main areas in Johannesburg, Pretoria, Cape Town
      and surrounds.
    </span>
  </div>
  <div class="actions">
    <button
      mat-stroked-button
      color="primary"
      (click)="regionService.toggleShowMap()"
      [disabled]="!state.region"
    >
      {{ (regionService.showMap$ | async) ? 'CLOSE' : 'SEE MAP' }}
    </button>
    <button
      mat-flat-button
      color="primary"
      *ngIf="state.mode === 'normal'"
      (click)="regionService.confirm(state)"
      [disabled]="regionService.disableConfirm$ | async"
      class="confirm-button"
      i18n="@@CallToAction.Confirm"
    >
      Confirm
    </button>

    <button
      mat-flat-button
      color="primary"
      *ngIf="state.mode === 'add-to-cart'"
      (click)="regionService.addToCart(state)"
      [disabled]="!regionService.isProductInSelectedRegion(state)"
      class="confirm-button"
    >
      <ng-container i18n="@@Checkout.AddToBag">Add to bag</ng-container>
    </button>
  </div>
</ng-container>
